import React, { useState, useRef, useEffect } from "react";
import Aos from 'aos';
import 'aos/dist/aos.css';
import price_img_1 from "../assets/Images/pricing_1.svg";
import price_img_2 from "../assets/Images/pricing_2.svg";
import packagesData from "./packages"
import { Box } from "@mui/material";
import VerifiedIcon from '@mui/icons-material/Verified';
import Dialog from '@mui/material/Dialog';
import Slide from '@mui/material/Slide';
const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="down" ref={ref} {...props} />;
});
const DirectionAwareCard = ({ title, about, actualPrice, details }) => {
  const [openModal, setOpenModal] = useState(false);  // State to control modal visibility
  const cardRef = useRef(null);
  const handleOpenModal = () => setOpenModal(true);  // Open the modal
  const handleCloseModal = () => setOpenModal(false);  // Close the modal
  useEffect(() => {
    Aos.init({ duration: 1000 });
  }, []);
  return (
    <div
      ref={cardRef}
      className="relative w-full h-full p-2"
    >
      <div style={{
        boxShadow: "rgba(14, 63, 126, 0.04) 0px 0px 0px 1px, rgba(42, 51, 69, 0.04) 0px 1px 1px -0.5px, rgba(42, 51, 70, 0.04) 0px 3px 3px -1.5px, rgba(42, 51, 70, 0.04) 0px 6px 6px -3px, rgba(14, 63, 126, 0.04) 0px 12px 12px -6px, rgba(14, 63, 126, 0.04) 0px 24px 24px -12px"
      }} className="w-full flex flex-col px-4  h-full rounded-2xl  justify-start py-3   transition duration-300 group overflow-hidden relative">

        <h3 className="capitalize text-3xl font-heading  my-6 h-16 text-orange">
          {title}
        </h3>
        <p className="text-lightGreen mb-3">
          {about}
        </p>
        <p className="text-lightGreen absolute bottom-24 mb-3">
          <span className="text-xl">Price (&#8377;)</span> :{" "}
          <span className="text-orange text-xl font-semibold">{actualPrice} /-</span>
        </p>
        <button onClick={handleOpenModal} className="py-3 absolute bottom-10 hover:bg-orange hover:border-orange hover:text-white transition-all hover:duration-200 border-[1px] border-lightGreen text-lightGreen rounded-3xl px-4 w-32">
          Read more
        </button>

      </div>
      {/* Modal Component */}
      <Dialog
        open={openModal}
        onClose={handleCloseModal}
        fullWidth
        maxWidth="sm" TransitionComponent={Transition}
        scroll="paper"
      >
        <Box
          sx={{
            bgcolor: 'background.paper',
            borderRadius: 8,
            p: { xs: 2, md: 4 },
            maxHeight: '600px',
            overflowY: { sm: "auto", md: "hidden" }
          }}
          className="rounded-3xl"
          style={{
            borderRadius: "24px !important"
          }}
        >
          <div>
            <h2 className="text-center font-heading text-thickGreen  md:text-3xl text-2xl md:my-3 ">
              Package Details
            </h2>
          </div>
          <h2 id="modal-title" className="md:text-2xl text-xl   text-center text-lightGreen font-heading capitalize md:my-3 my-1">
            {title}
          </h2>
          <div className="flex justify-between sm:flex-row flex-col items-center font-body">
            <p className="text-lightGreen text-xl">
            </p>
            <p className="text-lightGreen text-xl">
              <span>Price (&#8377;)</span> :{" "}
              <span className="text-orange">{actualPrice} /-</span>
            </p>
          </div>
          <p className="my-3 text-xl font-normal font-body capitalize text-orange">
            Investigations
          </p>
          <div
            id="modal-description"
            className="md:my-3 flex justify-around overflow-auto"
            style={{ maxHeight: '30vh' }}
          >
            {/* Desktop: Two Columns */}
            <div style={{ flex: 1 }} className="md:block hidden">
              {details?.slice(0, Math.ceil(details.length / 2)).map((item, index) => (
                <div key={index} className="my-2 pr-0.5">
                  <VerifiedIcon className="text-xl text-orange" />
                  &nbsp;&nbsp; {item}
                </div>
              ))}
            </div>
            <div style={{ flex: 1 }} className="md:block hidden">
              {details?.slice(Math.ceil(details.length / 2)).map((item, index) => (
                <div key={index} className="my-2">
                  <VerifiedIcon className="text-xl text-orange" />
                  &nbsp;&nbsp; {item}
                </div>
              ))}
            </div>
            {/* Mobile: Single Column */}
            <div style={{ flex: 1 }} className="md:hidden block">
              {details?.map((item, index) => (
                <div key={index} className="my-2">
                  <VerifiedIcon className="text-2xl text-orange" />
                  &nbsp;&nbsp; {item}
                </div>
              ))}
            </div>
          </div>
          <div className="flex justify-center items-center overflow-hidden">
            <button
              onClick={handleCloseModal}
              className="md:mt-4 mt-1 text-thickGreen px-12 md:py-3 py-1 rounded-full  font-medium border border-thickGreen bg-transparent flex justify-center items-center hover:bg-orange hover:text-white hover:border-orange text-[20px] transition-all hover:duration-200 text-center font-body"
            >
              Close
            </button>
          </div>
        </Box>
      </Dialog>
    </div>
  );
};
const Pricing = () => {
  const [packages, setPackages] = useState([]);
  useEffect(() => {
    setPackages(packagesData);
  }, []);
  return (

    <>

      <title>
        Best Diagnostic Lab Services and Blood Checkups in Hyderabad
      </title>
      <meta name="description" content="MagnAid Hospitals offers the best diagnostic lab services in Hyderabad, including blood checkups and lab services. Trust us for accurate and reliable results." />
      <div
        data-aos="fade-up"
        className="w-full flex flex-col justify-center pb-20 items-center px-2 md:px-0 border-b-[1px]"
      >
        <div className="3xl:w-4/5 xl:w-[90%] w-[95%] h-[300px] lg:h-[350px] flex justify-center  flex-col items-center rounded-3xl mt-8 bg-verylightGreen relative overflow-hidden">
          <div className="absolute -bottom-8 sm:bottom-0 right-0">
            <img src={price_img_1} alt="" className="sm:w-auto w-20" />
          </div>
          <div className="absolute sm:top-0 sm:left-0 -left-5 -top-6">
            <img src={price_img_2} alt="" className="sm:w-auto w-20" />
          </div>
          <h1
            className="lg:text-[58px] md:text-[48px] text-[36px] leading-[1.138em] font-heading text-thickGreen mb-4"
            data-aos="fade-right"
          >
            Lab & Diagnostic
          </h1>
          <h2
            className="text-4xl font-heading font-medium text-lightGreen"
            data-aos="fade-left"
          >
            All Packages
          </h2>
        </div>
        <div className="3xl:w-4/5 flex flex-row mt-20 flex-wrap justify-center xl:w-[95%] w-[95%]">
          {packages.map((item, index) => (
            <div
              data-aos="fade-up"
              className="xl:w-1/4 lg:w-1/3 md:w-1/2 w-full h-[400px] p-2"
              key={index}
            >
              <DirectionAwareCard
                title={item.name} about={item.about}
                actualPrice={item.actualPrice}
                details={item.investigations}
              />
            </div>
          ))}
        </div>
      </div>
    </>
  );
};

export default Pricing;
